import { createApiOperation } from "../api-client/create-api-operation";

export const Calibrations = {
  // Plant calibration operations
  uploadPlantCalibration: createApiOperation<
    never,
    "/Api/Plants/{datasetId}/{plantId}/Calibration",
    "post"
  >("/Api/Plants/{datasetId}/{plantId}/Calibration", "post"),

  getPlantCalibration: createApiOperation<
    never,
    "/Api/Plants/{datasetId}/{plantId}/Calibration",
    "get"
  >("/Api/Plants/{datasetId}/{plantId}/Calibration", "get"),

  deletePlantCalibration: createApiOperation<
    never,
    "/Api/Plants/{datasetId}/{plantId}/Calibration",
    "delete"
  >("/Api/Plants/{datasetId}/{plantId}/Calibration", "delete"),

  // Input calibration operations
  uploadInputCalibration: createApiOperation<
    never,
    "/Api/Inputs/{datasetId}/{inputId}/Calibration",
    "post"
  >("/Api/Inputs/{datasetId}/{inputId}/Calibration", "post"),

  getInputCalibration: createApiOperation<
    never,
    "/Api/Inputs/{datasetId}/{inputId}/Calibration",
    "get"
  >("/Api/Inputs/{datasetId}/{inputId}/Calibration", "get"),

  deleteInputCalibration: createApiOperation<
    never,
    "/Api/Inputs/{datasetId}/{inputId}/Calibration",
    "delete"
  >("/Api/Inputs/{datasetId}/{inputId}/Calibration", "delete"),
};
